import { useEffect, useRef, useState } from 'react';
import { Bell } from '../icons/index.jsx';
import IconButton from './IconButton.jsx';

const mockNotifications = [
  'Nueva guía #12345 creada',
  'Cliente ACME actualizado',
  'Reparto 220 listo para despacho',
  'Se generó el informe semanal de tesorería',
];

export default function NotificationsMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key === 'Escape') {
        setIsOpen(false);
        triggerRef.current?.focus({ preventScroll: true });
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return (
    <div className="relative" ref={containerRef}>
      <IconButton
        ref={triggerRef}
        aria-haspopup="true"
        aria-expanded={isOpen}
        aria-label="Ver notificaciones"
        title="Notificaciones"
        onClick={() => setIsOpen(prev => !prev)}
      >
        <Bell size={20} />
        {mockNotifications.length > 0 ? (
          <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white dark:ring-[rgb(2,27,33)]" aria-hidden="true" />
        ) : null}
      </IconButton>
      {isOpen ? (
        <div
          className="absolute right-0 mt-2 w-72 rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),1)] p-2 shadow-xl focus:outline-none z-50"
          role="menu"
          aria-label="Notificaciones recientes"
        >
          <header className="px-3 py-2 text-sm font-semibold text-[rgb(var(--fg))]">Notificaciones</header>
          <ul className="flex flex-col gap-1">
            {mockNotifications.map(notification => (
              <li
                key={notification}
                className="rounded-lg px-3 py-2 text-sm text-[rgb(var(--fg))]/90 hover:bg-[rgba(var(--subpanel),1)]"
                role="menuitem"
              >
                {notification}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
